<template>
  <div v-if="periodItem.id" class="register-form">
    <div class="view-panel view-panel1" :class="isPad?'view-panel-pad':''">
      <patient-info-card :patient="patient" :is-pad="isPad" ></patient-info-card>
      <div v-if="!isPad">
        <div class="info-title row">
          随访详情
        </div>
        <a-row class="row">
          <a-col :span="isPad?24:12" class="center-panel ">
            <div>
              周期类型
            </div>
            <div class="info-value">
              {{periodItem.name}}
            </div>
          </a-col>
          <a-col :span="isPad?24:12" class="center-panel">
            <div>
              当前状态
            </div>
            <div >
              <period-status-tag :status="periodItem.status" style="cursor: pointer"></period-status-tag>
            </div>
          </a-col>
        </a-row>
        <div class="center-panel row">
          当前周期表单完成率
        </div>
        <div class="center-panel info-value">
          0/10
        </div >
        <div class="center-panel row">可随访时间</div>
        <div class="center-panel info-value">
          {{periodItem.startDate}}~{{periodItem.endDate}}
        </div>
        <div class="center-panel info-value" v-if="periodItem.base!='1' && periodItem.groupName">
          {{periodItem.groupName}}
          <span style="color:orange; font-size:12px; font-weight:normal">{{periodItem.groupStatus=='2'?'终止':''}}</span>
        </div>
      </div>      
      <div class="info-title row">
        随访表单
      </div>
      <div class="form-panel" :class="isPad?'form-panel-pad':''" >
        <div v-for="(item,index) in formList" :key="index" class="form-item" :class="isPad?'form-item-pad':''"  @click="formClick(item.id)">
          <a-row v-if="!isPad">
            <a-col :span="2"> {{index+1}}</a-col>
            <a-col :span="13">
              <a-tooltip placement="topLeft" v-if="item.unnecessary===1" style="padding-right:2px">
                <template slot="title">
                  该表单可不填写
                </template>
                <a-icon type="info-circle" style="color: #FF4500" />
              </a-tooltip>
              {{item.name}}
            </a-col>
            <a-col :span="9" class="center-panel">
              <a-tag :color="textInfo[item.status].color" style="cursor: pointer">{{ textInfo[item.status].text }}</a-tag>
            </a-col>
          </a-row>
          <a-row v-else>
            <a-col :span="15">
              <a-tooltip placement="topLeft" v-if="item.unnecessary===1" style="padding-right:2px">
                <template slot="title">
                  该表单可不填写
                </template>
                <a-icon type="info-circle" style="color: #FF4500" />
              </a-tooltip>
              {{item.name}}
            </a-col>
            <a-col :span="8" class="center-panel">
              <a-tag :color="textInfo[item.status].color" style="cursor: pointer">{{ textInfo[item.status].text }}</a-tag>
            </a-col>
          </a-row>
        </div>
      </div>
    </div>
    <div class="view-panel view-panel2"  :class="isPad?'view-panel-pad':''">
      <a-row class="center-panel record" v-if="opList.length>0" >
        <a-col :span="4">
          <a-icon type="info-circle" />
          提交记录{{opList.length}}
        </a-col>
        <a-col :span="5">
          {{opList[0].createTime}}
        </a-col>
        <a-col :span="5">
          <label :style="{color:formOpStatus[opList[0].type].color}">【{{formOpStatus[opList[0].type].text}}】</label>
          {{opList[0].info}}
        </a-col>
        <a-col :span="5">
          <a-tooltip>
            <template slot="title">
              （说明：{{opList[0].description ||'-'}}）
            </template>
            <div class="one-row">（说明：{{opList[0].description ||'-'}}）</div>
          </a-tooltip>
        </a-col>
        <a-col :span="5">
          <a-button type="link" @click="viewOpList">查看全部</a-button>
        </a-col>
      </a-row>
      <div class="center-panel form-title">
        {{form.name}}
        <a-button style="float: right;margin-left: 5px" @click="recordingView">原始数据</a-button>
        <a-button style="float: right;margin-left: 5px" @click="clearFormValueHandle" v-has="'patientForm:deleteRecord'">删除记录</a-button>
        <a-button style="float: right;margin-left: 5px" @click="resetFormStatusHandle" v-has="'patientForm:resetRecord'">重置暂存</a-button>
        <a-button style="float: right;margin-left: 5px" @click="updateFromSubmit" v-has="'patientForm:updateSubmitRecord'" v-if="form.status=='3'">修改为正常提交</a-button>
      </div>

      <div class="form-item-panel">
        <form-view v-if="form.id" ref="formView" :base-data="form" @formChange="formChange" :is-load="false" :readOnly="!((form.status==='1' || form.status==='2') && answerUnexpired && answerOverdue)" >
          <template slot="btn">
            <!--<a-button type="primary" style="margin-left: 10px" :loading="loading" @click="submitHandle">提交</a-button>-->
            <template v-if="(form.status==='1' || form.status==='2') && answerUnexpired && answerOverdue">
              <a-button v-has="'patient:form:dismiss'" type="danger" :loading="loading" @click="lostHandle">失访</a-button>
              <a-button v-has="'patient:form:save'" style="margin-left: 10px" :loading="loading" @click="tempStorageHandle">暂存</a-button>
              <a-button v-has="'patient:form:submit'" type="primary" style="margin-left: 10px" :loading="loading" @click="submitHandle">提交</a-button>
            </template>
            <template v-else>
              <a-button v-has="'patient:form:modify'" type="primary" style="margin-left: 10px" :loading="loading" @click="handleUpdate">修改数据</a-button>
            </template>
          </template>
        </form-view>
      </div>
    </div>
    <a-modal
      title="失访"
      :width="600"
      :visible="lostVisible"
      :confirmLoading="loading"
      @ok="lostSubmit"
      @cancel="lostVisible = false">
      <a-alert message="操作失访后该表单将以已提交（失访）状态记录" type="info" show-icon />
      <div>失访原因：</div>
      <a-textarea v-model="lostCause" placeholder="请输入" :rows="2"  />
    </a-modal>
    <a-modal
      :title="formOpRecord.title"
      :width="600"
      :visible="formOpRecordVisible"
      :confirmLoading="loading"
      @ok="formOpRecordSubmit"
      @cancel="formOpRecordVisible = false">
      <a-alert :message="formOpRecord.description" type="info" show-icon />
      <div>操作原因：</div>
      <a-textarea v-model="formOpRecord.info" placeholder="请输入" :rows="2"  />
    </a-modal>
    <a-modal
      title="提交记录"
      :width="isPad?'100%':'60%'"
      :visible="viewOpVisible"
      :confirmLoading="loading"
      @ok="viewOpVisible = false"
      @cancel="viewOpVisible = false">
      <a-row class="center-panel record">
        <a-col :span="3"><strong>提交时间</strong></a-col>
        <a-col :span="2"><strong>提交人</strong></a-col>
        <a-col :span="4"><strong>题目名称</strong></a-col>
        <a-col :span="3"><strong>原有答案</strong></a-col>
        <a-col :span="3"><strong>修改答案</strong></a-col>
        <a-col :span="6"><strong>备注</strong></a-col>
        <a-col :span="3"><strong>描述</strong></a-col>
      </a-row>      
      <a-row class="center-panel record" style="margin-top:10px;" v-for="(op,index) in opList" :key="index" >
        <a-col :span="3">
          <!-- <a-icon type="info-circle" /> -->
          {{op.createTime}}
        </a-col>
        <a-col :span="2">
          {{op.opUserRealname || op.createBy}}
        </a-col>
        <a-col :span="4">
          {{op.formItemName}}
        </a-col>
        <a-col :span="3" >
          {{op.oldValue}}
        </a-col>
        <a-col :span="3" >
          {{op.newValue}}
        </a-col>
        <a-col :span="6">
          <label :style="{color:formOpStatus[op.type].color}">【{{formOpStatus[op.type].text}}】</label>
          {{op.info}}
        </a-col>
        <a-col :span="3" v-if="op.description">
          <a-tooltip>
            <template slot="title">
              （{{op.description ||'-'}}）
            </template>
            <div class="one-row">（{{op.description ||'-'}}）</div>
          </a-tooltip>
        </a-col>
      </a-row>
    </a-modal>
    <!--<a-modal-->
      <!--title="录音提醒"-->
      <!--:width="300"-->
      <!--:visible="recordingVisible"-->
      <!--:confirmLoading="loading"-->
      <!--@ok="recordingHandleOk"-->
      <!--@cancel="recordingVisible = false">-->
      <!--是否开始采集数据？-->
    <!--</a-modal>-->
    <a-drawer
      placement="right"
      @close="() => {recordingVisible = false}"
      :closable="false"
      :visible="recordingVisible"
      :loading="loading"
      width="80%"
    >
      <recording ref="recording" :patientName="patient.name" :recordingTip="recordingTip" :formId="form.id" :formName="form.name" :projectId="projectId" :patientId="patient.id"></recording>
    </a-drawer>
  </div>
  <a-empty
  v-else
  >
  <span slot="description"> 正在加载数据</span>

  </a-empty>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import PatientInfoCard from './components/PatientInfoCard'
  import { getAction,postAction } from '@/api/manage'
  import PeriodStatusTag from './components/followperiod/PeriodStatusTag'
  import Recording from './components/recording/Index'

  import moment from 'moment'
  import FormView from '../components/FormView'
  import {formStatus,formOpStatus} from '@/constants/patient'
  import { CACHE_PROJECT_ID} from '@/constants/project'
  import Vue from 'vue'
  export default {
    name: 'RegisterForm',
    components: { FormView, PeriodStatusTag, PatientInfoCard,Recording },
    data(){
      return {
        formItemNames:[],
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        lostCause:'',
        lostVisible:false,
        loading:false,
        dataLoading:false,
        form:{},
        patient:{},
        formList:[],
        periodItem:{},
        opList:[],
        now: new Date(moment().format('YYYY-MM-DD')),
        textInfo:formStatus,
        formOpStatus:formOpStatus,
        textInfoForm:{
          '1':{
            color:'red',
            text:'未到期'
          },
          '2':{
            color:'blue',
            text:'可随访'
          },
          '3':{
            color:'green',
            text:'已完成'
          },
        },
        viewOpVisible:false,
        isPad:this.$route.fullPath.startsWith('/pad'),
        project:{},
        recordingVisible:false,
        recordingTip:false,
        formOpRecordVisible:false,
        formOpRecord:{

        }
      }
    },

    computed:{
      // 允许未到期作答
      answerUnexpired(){
        if(this.periodItem.id){
          if(this.periodItem.status ==='1'){
            return this.periodItem.answerUnexpired==='1'
          }
          else {
            return true
          }
        }
        return false
      },
      // 允许过期作答
      answerOverdue(){
        if(this.periodItem.id){
          if(this.periodItem.status ==='3'){
            return this.periodItem.answerOverdue==='1'
          }
          else {
            return true
          }
        }
        return false
      },
    },
    mounted() {
      this.loadDataBase()
    },
    methods:{
      formChange(formItem){
        if(this.$refs.formView && this.form.status==='2' || this.form.status==='1'){
          const formData = this.$refs.formView.getFormData()
          postAction('/patient/patientForm/tempStorage',{status:'2',id:this.form.id,itemForm:JSON.stringify(formData)}).then(res=>{
            if(res.success){
              if(!this.formItemHasRecord(formItem.id) && this.$refs.recording){
                this.$refs.recording.submitFormHandle(formItem,this.recordSubmitHandle(formItem.id))
              }
              postAction('/patient/patientForm/cascade',{formId:this.form.id,patientId:this.form.patientId,formItemId:formItem.id}).then(res=>{
                if(res.success){
                  if(res.result){
                    for (let key in res.result){
                      this.$refs.formView.setFormData(key,res.result[key])
                    }
                  }
                }else{
                  this.$message.error(res.message)
                }
              })
              //质疑提示
              postAction('/patient/patientForm/questionTip',{patientFormItemId:formItem.id,projectId:this.form.projectId}).then(res=>{
                if(res.success){
                  debugger
                  if(res.result!=null && res.result.length>0){
                    this.$message.error({
	 content: h(
	     'div',
	     { style: 'display:inline-table;text-align:left;vertical-align: top;max-width:300px;max-height:500px;' },
	     res.result.map((line, index) => {
	       return [
	        (
	          'div',
	          { style: 'display:inline-table;text-align:left;vertical-align: top;' },
	          index+1 + "：" + line
	         ),
	         index < res.result.length - 1 ? <br /> : null
	       ]
	     })
	   )
	})
                  }
                }else{
                  this.$message.error(res.message)
                }
              })
            }else{
              this.$message.error(res.message)
            }
          })
        }
      },
      recordSubmitHandle(formItemId){
        const formItemEntity = this.getFormItem(this.form.formItemList,formItemId)
        formItemEntity.recording = '1'
      },
      formItemHasRecord(formItemId){
        let result = false
        const formItemEntity = this.getFormItem(this.form.formItemList,formItemId)
        if(formItemEntity.recording=='1'){
          result = true
        }
        return result
      },
      getFormItem(formItemList,formItemId){
        let result = null
        formItemList.forEach(item=>{
          if(result!=null){
            return
          }
          if(item.id==formItemId ){
            result = item
          }else{
            if(item.children && item.children.length>0){
              result = this.getFormItem(item.children,formItemId)
            }
          }
        })
        return result
      },
      loadDataBase(){
        this.loadData(this.$route.params.id)
      },
      loadData(patientFormId,resultView){
        patientFormId = patientFormId || this.$route.params.id
        this.loadFormData(patientFormId,resultView)
        getAction('/patient/patientFormItemOp/list',{formId:patientFormId}).then(res=>{
          if(res.success){
            this.opList = res.result
          }
        })

      },
      loadFormData(patientFormId,resultView){
        this.dataLoading = true
        getAction('/patient/patient/getFormViewInfo',{patientFormId:patientFormId}).then(res=>{
          if(res.success){
            //加载患者信息，
            //加载所在周期信息
            //加载周期的表单信息
            //加载表单信息
            this.form = res.result.form
            this.periodItem = res.result.periodItem
            this.patient = res.result.patient
            this.formList = res.result.formList
            this.recordingTip = false
            this.$nextTick(()=>{
              this.$refs.formView.loadData(resultView)
            })
            this.$nextTick(()=>{
              // 重新加载语音数据
              if(this.$refs.recording){
                this.$refs.recording.loadData()
              }
            })

            // 获取项目ID配置
            getAction('/management/project/getInfoById',{id:this.projectId}).then(res=>{
              if(res.success){
                this.project = res.result
                // 判断开启录音提醒
                if(this.form.status==='1' || this.form.status==='2'){
                  // 暂时只有pad端开启提醒
                  if(this.isPad && this.project.recording==='1'){
                    this.recordingVisible = true
                    this.$nextTick(()=>{
                      this.recordingVisible = false
                      this.recordingTip = true
                    })
                  }
                }
              }
            })
          }
        }).finally(()=>{
          this.dataLoading = false
        })
      },
      formClick(patientFormId){
        this.loadData(patientFormId)
      },
      handleUpdate(){
        if(this.isPad){
          this.$router.push({path:'/pad/question/checkForm/'+this.form.id})
        }else{
          this.$router.push({path:'/project/datacheck/checkform/'+this.form.id})

        }
      },
      viewOpList(){
        this.viewOpVisible = true
      },
      // 失访
      lostHandle(){
        this.lostVisible = true
      },
      lostSubmit(){
        this.lostVisible = false
        if(!this.lostCause){
          return this.$message.warning('请填写失访原因');
        }
        this.postSubmit('/patient/patientForm/lost','5',this.lostCause)
      },
      // 暂存
      tempStorageHandle(){
        this.postSubmit('/patient/patientForm/tempStorage','2')
      },
      // 提交
      submitHandle(){
        this.formItemNames = []
        const validateResult = this.$refs.formView.validate()
        if(!validateResult[0]){
          const formItemNames = []
          for (let key in validateResult[1]){
            this.form.formItemList.forEach(item=>{
              if(item.id===key){
                formItemNames.push(`${item.name}`)
              }
            })
          }
          this.formItemNames = formItemNames
          // 尚有未完成的表单，是否提交表单并且标记表单为“数据缺失” ?
          this.$confirm({
            title: '提示',
            content:h => {
              const infoList = ['尚有未完成的表单，是否提交表单并且标记表单为“数据缺失” ?']
              formItemNames.forEach(item=>{
                infoList.push(h('div',{},item))
              })
              return h(
                'div',
                {},
                infoList,
              );
            },
            onOk:()=> {
              this.postSubmit('/patient/patientForm/submit','3',)
            },
            onCancel:() =>{
            },
          });
        }else{
          this.postSubmit('/patient/patientForm/submit','4',)
        }
      },
      postSubmit(url,status,lostCause){
        if(this.$refs.recording){
          // 提交完整的语音
          this.$refs.recording.saveAllRecorder2()
        }
        const submitFn = ()=>{
          const validateResult = this.$refs.formView.validate()
          const errData = validateResult.length>1?validateResult[1]: { }
          const formData = this.$refs.formView.getFormData()
          const errParams = {}
          for (let key in errData){
            const message = errData[key][0].message===baseRules.required.message ?'必填项缺失':errData[key][0].message
            errParams[key] = message
          }
          this.loading = true
          postAction(url,{status:status,id:this.form.id,lostCause:lostCause,errParams:JSON.stringify(errParams),itemForm:JSON.stringify(formData)}).then(res=>{
            if(res.success){
              this.loadData(this.form.id,true)
              this.$message.success(res.message)
              // 结论弹出
            }else{
              this.$message.error(res.message)
            }
          }).finally(()=>{
            this.loading = false
          })
        }
        submitFn()
        if(this.$refs.recording){
          // 要结束语音
          this.$refs.recording.closeFormHandle()
        }


      },
      recordingView(){
        this.recordingVisible=true
      },
      updateFromSubmit(){
        this.$confirm({
          title: '确认修改为“正常提交”？',
          content: '是否确认修改为“正常提交”？',
          onOk:()=> {
            postAction('/patient/patientForm/updateFormSubmit',{id:this.form.id}).then(res=>{
              if(res.success){
                this.loadDataBase()
              }
            })
          },
        });
      },
      /**
       * 清空记录
       */
      clearFormValueHandle(){
        this.formOpRecord = {
          title:'删除记录',
          description:'该操作将删除当前提交记录(谨慎操作)，清除当前的数据!!!',
          info:'',
          type:'7',
        }
        this.formOpRecordVisible = true
      },
      /**
       * 重置暂存
       */
      resetFormStatusHandle(){
        this.formOpRecord = {
          title:'重置暂存',
          description:'该操作将重置当前提交记录为暂存状态，保留当前的最新数据!!!并且已有质疑修、改记录、评分将会清除!!!',
          info:'',
          type:'8',
        }
        this.formOpRecordVisible = true
      },
      /**
       * 表单操作保存
       */
      formOpRecordSubmit(){
        if(!this.formOpRecord.info){
          return this.$message.warning('请输入操作原因')
        }
        const params={
          formId:this.form.id,
          type:this.formOpRecord.type,
          patientId:this.form.patientId,
          description:this.formOpRecord.info,
        }
        this.loading = true
        postAction('/patient/patientForm/formOp',params).then(res=>{
          if(res.success){
            this.loadDataBase()
            this.formOpRecordVisible = false
          }
        }).finally(()=>{
          this.loading = false
        })
      },
    },
    beforeDestroy(){
      if(this.$refs.recording){
        // 结束录音
        this.$refs.recording.closeFormHandle(()=>{

        })
      }
    }
  }
</script>

<style scoped lang="less">
  .register-form{
    padding: 10px;
    .view-panel{
      border: 1px solid rgba(0,0,0,0.2);
      overflow-y: auto;
      padding: 10px;
      height: calc(100vh - 150px);
    }
    .view-panel-pad{
      height: calc(100vh - 75px) !important;
    }
    .view-panel-pad::-webkit-scrollbar { width: 0 !important }


    .view-panel-pad { -ms-overflow-style: none; }


    .view-panel-pad { overflow: -moz-scrollbars-none; }
    .view-panel1{
      width: 20%;
      float: left;
    }
    .view-panel2{
      margin-left: 20px;
      float: left;
      width: calc(80% - 20px);
    }
    .form-item{
      border-bottom: 1px solid rgba(0,0,0,0.1);
      padding: 10px;
      cursor: pointer;

    }
    .form-item-pad{
      padding: 5px 2px !important;
    }
    .form-item:hover{
      border: 1px solid rgba(57,188,206,0.5);
      border-radius: 5px;
    }
    .info-title{
      font-size: 16px;
    }
    .row{
      margin-top: 10px;
    }
    .info-value{
      font-size: 18px;
      font-weight: bold;
    }
    .form-panel{
      max-height: calc(100vh - 550px);
      overflow-y: auto;
      overflow-x: hidden;
    }
    .form-panel-pad{
      min-height: 300px!important;
    }
    .record{
      border:1px solid rgba(57,188,206,0.5);
      border-radius: 5px;
      padding: 5px;
      margin: 5px 10px;
    }    
    .form-title{
      font-size: 22px;
      margin-top: 5px;
    }
    .form-item-panel{
      overflow-y: auto;
    }

  }
</style>